// lib/meterSentence.ts — TODAY-W's own sentence (CockpitToday.tsx),
// extracted so H1a's gauges row states a meter's reading in EXACTLY the
// same words rather than a second, possibly-drifting copy — the brief's
// own requirement ("states its sentence on tap exactly as CockpitToday.tsx's
// meterSentence does"). "Never colour alone" (voice canon §2.7): the word
// carries the cap, not a border colour. Stale takes priority over the
// meter reading because a stale fact's number cannot be trusted to be the
// current one.
import type { TodaySystemFact } from './api';

export function meterSentence(f: TodaySystemFact): string {
  if (f.stale) {
    const since = f.staleSince
      ? new Date(f.staleSince).toLocaleString([], { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
      : '';
    return `${f.label} stale since ${since}`;
  }
  const unit = f.unit ?? '';
  const reading = f.valueNum !== null && f.capNum !== null ? `${f.valueNum}${unit} of ${f.capNum}${unit}` : f.state;
  if (f.meter === 'at_cap') return `${f.label} at cap — ${reading}`;
  if (f.meter === 'near') return `${f.label} near cap — ${reading}`;
  return `${f.label} — ${reading}`;
}
